// ── The Last Kingdom card: the shared 3D card body dressed in kingdom colours,
//    with the painted card art on the revealed face. ──

import Card3D from '../arena/Card3D';

const CARD_NATURE = {
  1:  '#ef4444', 2:  '#84cc16', 3:  '#f97316',
  4:  '#a8a29e', 5:  '#a8a29e', 6:  '#a8a29e',
  7:  '#60a5fa', 8:  '#f59e0b', 9:  '#f59e0b', 10: '#4ade80',
};

const KINGDOM_BACK = {
  Italy:   { deep: '#000d04', mid: '#00300b', rim: '#0b7a3d', gold: '#ffd700', glow: 'rgba(0,160,70,0.42)', emblem: '♛' },
  Spain:   { deep: '#120002', mid: '#420009', rim: '#a3101f', gold: '#ffc400', glow: 'rgba(220,50,40,0.42)', emblem: '♛' },
  France:  { deep: '#000210', mid: '#000a3c', rim: '#2b46ad', gold: '#e8edff', glow: 'rgba(60,95,225,0.45)', emblem: '♛' },
  England: { deep: '#0d0002', mid: '#3f0008', rim: '#a30d24', gold: '#ffffff', glow: 'rgba(220,60,70,0.42)', emblem: '♛' },
  Unknown: { deep: '#080500', mid: '#2c1c00', rim: '#c9951c', gold: '#ffd700', glow: 'rgba(230,170,30,0.4)', emblem: '♛' },
};

const KingdomCard3D = ({ card, index, onPick, canPick, mobile = false, kingdom = 'Unknown', isRevealing = false }) => (
  <Card3D
    revealed={card.revealed}
    index={index}
    onPick={onPick}
    canPick={canPick}
    isRevealing={isRevealing}
    mobile={mobile}
    back={KINGDOM_BACK[kingdom] || KINGDOM_BACK.Unknown}
    tone={CARD_NATURE[card.value] || CARD_NATURE[4]}
    front={(
      <img
        src={`/cards/card_${card.value}.png`}
        alt={`Carta ${card.value}`}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        draggable={false}
      />
    )}
  />
);

export default KingdomCard3D;
